import { RootState } from '@app/redux/root-reducer';

export const selectEmployeesState = (store: RootState) => store.employeesReducer.employees;

export const selectAddEmployeeState = (store: RootState) => store.employeesReducer.addEmployee;

export const selectUpdateEmployeeStatusState = (store: RootState) =>
  store.employeesReducer.updateEmployeeStatus;
export const selectUpdateEmployeeState = (store: RootState) =>
  store.employeesReducer.updateEmployee;
export const selectEmployeeDetailsState = (store: RootState) =>
  store.employeesReducer.employeeDetails;
export const selectEmployeeActivityById = (store: RootState) =>
  store.employeesReducer.employeeActivity;
export const selectSearchEmployeesInternsState = (store: RootState) =>
  store.employeesReducer.searchEmployeesInterns;
